export default __webpack_public_path__ + "static/media/kp.a5ee8d39.jpeg";